import request from '@/utils/request'

// 查询常见问题解决状态记录分页
export function pageProblemSolve(data) {
  return request({
    url: '/help/problemSolve/page',
    method: 'get',
    params: data
  })
}
